import { useSelector } from 'react-redux';
import clsx from 'clsx';
import Header from '../../Header';
import TravelOptions from '../../TravelOptions';
import TravelOptionsPagination from '../../TravelOptionsPagination';
import TripSearchProgressBar from '../../TripSearchProgressBar';
import QuickLinks from '../../QuickLinks';
import Trips from '../../Trips';
import ContactAdvisor from '../../ContactAdvisor';
import { placementOptions, SearchStatus } from '../../../constants';
import PollingSearchProgressBar from '../../PollingSearchProgressBar';
import Footer from '../../Footer';
import TravelBlurbs from '../../TravelBlurbs';
import AgencyNotification from '../../AgencyNotification/index';
import useAgencyNotifications from '../../../hooks/useAgencyNotifications';

const HomeAgent = () => {
  const { searchStatus, deepLinkSearchStatus, usefulLinks, travelAgency } = useSelector(
    (state) => ({
      searchStatus: state.tripSearch.searchStatus,
      deepLinkSearchStatus: state.hotel.deepLinkSearchStatus,
      usefulLinks: state.user.usefulLinks,
      travelAgency: state.user.travelAgency,
    }),
  );

  const doShowFooterOnEachPages = travelAgency?.settings?.doShowFooterOnEachPages;
  const belowSearchbarNotifications = useAgencyNotifications(placementOptions.BELOW_SEARCHBAR);
  const dashboardNotifications = useAgencyNotifications(placementOptions.DASHBOARD);

  return (
    <div className="bg-body-0 min-h-screen flex flex-col">
      <Header />
      <div className="flex-grow">
        {belowSearchbarNotifications.length > 0 &&
          belowSearchbarNotifications.map((notification) => (
            <div className="container mx-auto" key={notification.id}>
              <AgencyNotification
                notification={notification}
                placement={placementOptions.BELOW_SEARCHBAR}
              />
            </div>
          ))}
        <div className="h-5">
          <TripSearchProgressBar />
          <PollingSearchProgressBar />
        </div>
        <div
          className={clsx('container mx-auto px-2 sm:px-0', {
            'min-h-112': doShowFooterOnEachPages,
          })}
        >
          {(searchStatus || deepLinkSearchStatus) !== SearchStatus.INITIAL ? (
            <>
              <TravelBlurbs />
              <TravelOptionsPagination />
              <TravelOptions />
              <TravelOptionsPagination doShowSort={false} />
              <ContactAdvisor />
            </>
          ) : (
            <div className="container mx-auto space-y-6">
              {dashboardNotifications.length > 0 ? (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
                    <div className="md:col-span-4 space-y-4">
                      {dashboardNotifications.map((notification) => (
                        <AgencyNotification
                          key={notification.id}
                          notification={notification}
                          placement={placementOptions.DASHBOARD}
                        />
                      ))}
                      <div className="mt-6">
                        <Trips />
                      </div>
                    </div>
                    <div className="md:col-span-2">
                      <QuickLinks />
                    </div>
                  </div>
                </>
              ) : (
                <div
                  className={clsx({
                    'grid grid-cols-5 gap-6 divide-x divide-gray-400':
                      usefulLinks && usefulLinks.length > 0,
                  })}
                >
                  <div className="col-span-3 md:col-span-4">
                    <Trips />
                  </div>
                  <QuickLinks />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HomeAgent;
